import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Button, Select, MenuItem, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputAdornment, Autocomplete, ButtonGroup, Tooltip, IconButton, Checkbox, FormControlLabel, TablePagination } from "@mui/material";
import { useState } from "react";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { SelectProductsModal } from "./components/SelectProductsModal";
import { withStyles } from '@mui/styles';
import { usePriceListStore } from "../../hooks/usePriceListStore";
import { readLocalStorage } from "../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../types";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { DetailListModal } from "./components/DetailListModal";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import SearchIcon from '@mui/icons-material/Search';
import '../../assets/styles/facturacionv3-app.css'

const StyledTableCell = withStyles((theme) => ({
    head: {
    color: theme.palette.common.black,
    },
    body: {
    fontSize: 14,
    },
}))(TableCell);

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'cost', label: 'Costo', align:'center' },
    { type: 'text', field: 'price', label: 'Precio', align:'center' },
    { type: 'text', field: 'discount', label: 'Max. descuento', align:'center' },
    { type: 'text', field: 'stock', label: 'Cantidad', align:'center' },
    // { type: 'text', field: 'subtotal', label: 'Subtotal', align:'center' },
];

type Values = {
    idpricelist: number,
    code: string,
    status: string,
}

export const AddProducts: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, listSelected, showProducts, setAddProduct, clearState } = props;

    const { addProducts } = usePriceListStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const [loading, setLoading] = useState<boolean>(false);
    const [showaddProduct, setShowaddProduct] = useState<boolean>(false);
    const [showListProducts, setShowListProducts] = useState<boolean>(false);
    const [productsSelected, setProductsSelected] = useState<any>([]);
    const [filter, setFilter]= useState<any>([]);
    const [assignedvalue, setassignedvalue] = useState<any>(0);
    const [state, setState] = useState<any>({
        discount: false,
        stock: false,
    });
    const [data, setData] = useState<Values>({
        idpricelist: listSelected ? listSelected.id :'',
        code: listSelected ? listSelected.code :'',
        status: listSelected ? listSelected.status :'1',
    });
    const [page, setPage] = useState<number>(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)

    const validateForm = (values) => {
        let errors:any = {};
        // if(!values.code) errors.code = "el campo es requerido";
        // if(!values.name) errors.name = "el campo es requerido";
        // if(!values.validity_date) errors.validity_date = "el campo es requerido";
        // if(!values.quantity_products) errors.quantity_products = "el campo es requerido";
        // if(!values.type) errors.type = "el campo es requerido";
        // if(!values.status) errors.status = "el campo es requerido";
        // if(values.type == '2' && !values.idbranchoffice) errors.idbranchoffice = "el campo es requerido";
        return errors;
    }

    const addProductsModal = () => {
        setShowListProducts(true);
    }

    const changeInputs = (id: number, value: number = 0, type: string) => {
        const product = filter.find(product => product.id === id)
        if(product) {
            switch (type) {
                case 'price':
                    product.price = value
                    break;
                case 'cost':
                    product.cost = value
                    break;
                case 'discount':
                    product.discount = value
                    break;
                case 'stock':
                    product.stock = value
                    break;
            }
        };
        setFilter([...filter])

        const newTotal = filter.reduce((acc, row) => {
            return acc + (row.price * row.stock);
        }, 0);
        // setTotal(newTotal);
    }

    const OnCheckbox = (e) => {
        const name = e.target.name;
        switch (name) {
            case 'discount':
                setState({
                    discount: e.target.checked,
                    stock: !e.target.checked ? state.stock : false
                });
                break;
            case 'stock':
                setState({
                    stock: e.target.checked,
                    discount: !e.target.checked ? state.discount : false,
                });
                break;
            default:
                break;
        }
    }

    const handleAssignStockOrDiscount = (e) => {
        e.preventDefault();
        const data = [...filter];

        if(data.length == 0) return CustomSnackbar('error', "Aún no ha seleccionado productos");

        if(state.stock){
            const updatedData = data.map((row) => ({
                ...row,
                stock: assignedvalue,
            }));
            setFilter(updatedData);
        }
        if(state.discount){
            const updatedData = data.map((row) => ({
                ...row,
                discount: assignedvalue,
            }));
            setFilter(updatedData);
        }
        // setState({ discount: false, stock: false });
        setassignedvalue(0);
    };

    const onDeleteProduct = (row) => {
        const products = filter.filter(product => product.id !== row.id)
        setFilter([...products]);

        const newTotal = products.reduce((acc, product) => {
            return acc + (product.price * product.stock);
        }, 0);
    }

    const handleSearch = (searchTerm) => {
        const filtered = productsSelected.filter((product) =>
            product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilter(filtered);
        if (!searchTerm) {
            setFilter([...productsSelected])
        }
    };

    const onSubmit = async(values)  => {
        setLoading(true);

        if(filter && filter.length == 0) {
            setLoading(false)
            return CustomSnackbar('error', "Aún no ha seleccionado productos.")
        };

        let formdata = {
            ...values,
            products: filter || [],
            idcompany: idcompany
        }

        console.log(formdata)

        const response:any = await addProducts(formdata);
        if(response){
            showProducts && showProducts(listSelected);
            setAddProduct && setAddProduct(false);
            closeModal && closeModal();
            clearState && clearState();
            setLoading(false);
        }else{
            setLoading(false);
            return false;
        }
    }

    const handleChangePage = (event:any, newPage:any) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event:any) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (
        <>
        <CustomForm >
            <CustomFormHeader
                title={'Agregar productos a la lista'}
                onCancel={closeModal}
                clearState={clearState}
            >
            </CustomFormHeader>
            <CustomFormBody>

                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'3px 20px 20px 20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        {
                                            filter.length > 0 && (
                                                <Grid item xs={12}>
                                                    <div>
                                                        <FormControlLabel control={<Checkbox checked={state.stock} onChange={OnCheckbox} />} label="Asignar cantidad" name="stock" disabled={state.discount ? true : false}/>
                                                        <FormControlLabel control={<Checkbox checked={state.discount} onChange={OnCheckbox} />} label="Asignar descuento" name="discount" disabled={state.stock ? true : false}/>
                                                    </div>
                                                    {
                                                        (state.discount || state.stock ) && (
                                                            <Grid item container xs={12} spacing={2} sx={{alignItems: 'center', marginBottom:'5px'}}>
                                                                <Grid item xs={12} md={2}>
                                                                    <TextField
                                                                        id={"input"}
                                                                        type="number"
                                                                        fullWidth
                                                                        size="small"
                                                                        inputProps={{ min: 0 }}
                                                                        value={assignedvalue}
                                                                        onChange={(e)=>{setassignedvalue(e.target.value)}}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={3}>
                                                                    <button onClick={(e)=>{handleAssignStockOrDiscount(e)}} style={{cursor:'pointer'}}>
                                                                        {state.discount && 'Asignar descuento para todos'}
                                                                        {state.stock && 'Asignar stock para todos'}
                                                                    </button>
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    }
                                                </Grid>
                                            )
                                        }
                                        <Grid item xs={12}>
                                            <Grid item xs={12} sx={{marginBottom:'10px'}}>
                                                <FormLabel>Lista de productos a agregar</FormLabel>
                                            </Grid>
                                            <Grid  item xs={12} display='flex' justifyContent='space-between' alignContent='center' alignItems='center' mb={2}>
                                                <Grid item>
                                                    <TextField
                                                        InputProps={{
                                                            startAdornment: (
                                                            <InputAdornment position="start">
                                                            <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                            )
                                                        }}
                                                        onChange={(e)=>{handleSearch(e.target.value)}}
                                                        placeholder="Buscar..."
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Button onClick={addProductsModal}  size="small" variant="contained" className='btn-secondary'>
                                                    {'seleccionar productos'}
                                                </Button>
                                            </Grid>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead className="table-header">
                                                        <TableRow>
                                                            {columns.map((column:any, i:any) => (
                                                                <StyledTableCell className="table-header-text" key={i} align='center'>
                                                                    {column.label}
                                                                </StyledTableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            filter.length > 0  ? (
                                                                filter.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((row) => (
                                                                    <TableRow key={row.id}>
                                                                        <TableCell className="cellTable" align="center" style={{fontSize:"13px"}}>
                                                                            <ButtonGroup variant="contained" aria-label="button-group-custom-table" style={{padding: "0px 5px", color:"#808080"}}>
                                                                                <Tooltip title={'Eliminar'}>
                                                                                    <IconButton size="small" color="inherit" aria-label="delete" onClick={() => { onDeleteProduct(row) } }>
                                                                                        <DeleteOutlineIcon fontSize='small' />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </ButtonGroup>
                                                                        </TableCell>
                                                                        <TableCell align="center">{row.code_system}</TableCell>
                                                                        <TableCell align="center">{row.name}</TableCell>
                                                                        <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                value={row.cost}
                                                                                InputProps={{
                                                                                    startAdornment: <InputAdornment position="start">{row.cointypesymbol}</InputAdornment>,
                                                                                }}
                                                                                inputProps={{ min: 0 }}
                                                                                onChange={(e) => changeInputs(row.id, parseFloat(e.target.value), 'cost')}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                value={row.price}
                                                                                InputProps={{
                                                                                    startAdornment: <InputAdornment position="start">{row.cointypesymbol}</InputAdornment>,
                                                                                }}
                                                                                inputProps={{ min: 0 }}
                                                                                onChange={(e) => changeInputs(row.id, parseFloat(e.target.value), 'price')}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                inputProps={{ min: 0 }}
                                                                                value={row.discount}
                                                                                onChange={(e) => changeInputs(row.id, parseInt(e.target.value), 'discount')}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <TextField
                                                                                id={"input-" + row.id}
                                                                                type="number"
                                                                                fullWidth
                                                                                size="small"
                                                                                inputProps={{ min: 0 }}
                                                                                value={row.stock}
                                                                                onChange={(e) => changeInputs(row.id, parseInt(e.target.value), 'stock')}
                                                                            />
                                                                        </TableCell>
                                                                        {/* <TableCell align="center">{row.cointypesymbol + ' ' + (row.price * row.stock)}</TableCell> */}
                                                                    </TableRow>
                                                                ))
                                                            ) : (
                                                                <TableRow>
                                                                    <TableCell colSpan={columns ? columns.length : 1}>
                                                                        <Grid sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                                                            <div>{"Sin data"}</div>
                                                                        </Grid>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination
                                                component="div"
                                                rowsPerPageOptions={[5, 10, 25, 100]}
                                                count={filter.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                labelRowsPerPage="Filas por página"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <CustomFormFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                    loadingConfirmText={loading}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </CustomFormBody>
        </CustomForm>
        {
            showaddProduct && (
                <DetailListModal
                    open = {showaddProduct}
                    closeModal = {() => {setShowaddProduct(false)}}
                    clearState = {clearState}
                    listSelected= {listSelected}
                />
            )
        }
        {
            showListProducts && (
                // <SelectProductsModal
                //     open = {showListProducts}
                //     closeModal = {() => {setShowListProducts(false)}}
                //     clearState = {clearState}
                //     productsSelected = {productsSelected}
                //     setProductsSelected = {setProductsSelected}
                // />

                <SelectProductsModal
                    open = {showListProducts}
                    closeModal = {() => {setShowListProducts(false)}}
                    clearState = {clearState}
                    // productsSelected = {productsSelected}
                    productsSelected = {filter}
                    setProductsSelected = {setProductsSelected}
                    setFilter = {setFilter}
                />
            )
        }
        </>
    )
}